import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";

interface CodeBlockProps {
  children: ReactNode;
  maxHeight?: number;
  sx?: SxProps<Theme>;
}

export default function CodeBlock({
  children,
  maxHeight = 300,
  sx,
}: CodeBlockProps) {
  return (
    <Box
      component="pre"
      sx={[
        (theme) => ({
          p: 2,
          bgcolor: "grey.50",
          ...theme.applyStyles("dark", {
            bgcolor: "grey.800",
          }),
          color: "text.primary",
          borderRadius: 1,
          fontSize: "0.8rem",
          overflow: "auto",
          maxHeight,
          whiteSpace: "pre-wrap",
          wordBreak: "break-all",
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  );
}
